module.exports = __webpack_public_path__ + "static/img/100.80f8c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/100.png
// module id = Ns7w
// module chunks = 3